import { Box, styled } from '@mui/material';

import { StyledExtraSmallIcon } from 'components/shared/Icon/Icon.styles';

/** Class hooks the styles below toggle, so the swap needs no React state. */
export const DROP_INDICATOR_CLASS = 'traveltime__indicator';
export const TRAVEL_TIME_TEXT_CLASS = 'traveltime__text';

/** Marks a travel time that registers a drop target. */
export const DROPPABLE_ATTRIBUTE = 'data-droppable';

// The negative margin is what compresses the 70px block into the ~30px gap the
// column actually shows, so it is layout, not hit area: it also reaches into
// the cards on either side, but since the cards became drop targets themselves
// that overlap only decides which element wins it — the card, which resolves it
// to this same slot.
export const StyledTravelTime = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px 0',
  margin: '-20px 0',
  width: '100%',
  minHeight: '70px',
  position: 'relative',
  zIndex: 1,
  // Text-selectable content here is what lets a mouse-drag start as a text
  // selection instead of a card drag (see dragSelection.ts) — the travel time
  // is never meant to be copyable, so opting it out is a pure win.
  userSelect: 'none',
  // Swap the travel time for the drop indicator through the attribute
  // `useDropTarget` sets, so a drag crossing the column doesn't re-render
  // every travel-time row it passes over.
  [`& .${DROP_INDICATOR_CLASS}`]: { display: 'none' },
  [`&[data-drag-over] .${DROP_INDICATOR_CLASS}`]: { display: 'block' },
  [`&[data-drag-over] .${TRAVEL_TIME_TEXT_CLASS}`]: { display: 'none' },
  // Non-droppable traveltimes register no drop target but still visually
  // overlap an adjacent FreeTime via negative margins. Make the <li>
  // transparent to hit-testing during a drag so the FreeTime sibling beneath
  // becomes the hit target and lights up. Driven off the attribute rather than a
  // styled prop so the polymorphic `component` typing of Box survives.
  [`[data-drag-active] &:not([${DROPPABLE_ATTRIBUTE}])`]: {
    pointerEvents: 'none'
  }
}) as typeof Box;

export const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '2px 8px',
  whiteSpace: 'nowrap',
  zIndex: 10,
  fontSize: theme.typography.body2.fontSize
}));

export const RouteIcon = styled(StyledExtraSmallIcon, {
  shouldForwardProp: (prop) => prop !== 'isCarRoute'
})<{ isCarRoute: boolean }>(({ theme, isCarRoute }) => ({
  fontSize: isCarRoute ? theme.spacing(3) : theme.spacing(4),
  marginRight: theme.spacing(2)
}));
